import { COMM_COLL, firestore } from "_firebase";
import { isEmpty, cloneDeep } from "lodash";
import { mergeObjects } from "utils/objects";

import { actions as commUpgradesActions } from "./";

const { 
    saveUpgradesStart,
    saveUpgradesSuccess,
    toggleUpgradesLoading,
    setUpgradesError,
    setInitUpgradePackages,
    setUpgradePackages,
    initCapitalCosts
} = commUpgradesActions;

export const saveUpgrades = () => async (dispatch, getState) => {
    try {
        dispatch(saveUpgradesStart());

        const {
            community: { communityId } = {},
            commUpgrades: { packages = {}, initPackages = {}, initPackagesSnapshot = {}, capitalCosts = {} } = {},
        } = getState();

        if (!communityId) {
            return;
        }

        const newPackages = mergeObjects(packages, initPackages, initPackages); // initPackagesSnapshot is empty

        await firestore
            .doc(`${COMM_COLL}/${communityId}`)
            .collection("upgrades")
            .doc("upgradePackages")
            .set(newPackages);
        await firestore.doc(`${COMM_COLL}/${communityId}`).collection("upgrades").doc("capitalCosts").set(capitalCosts);

        dispatch(setInitUpgradePackages({ packages: newPackages }));
        dispatch(setUpgradePackages({ packages: newPackages }));
        dispatch(saveUpgradesSuccess());
    } catch (error) {
        console.log(error.message);
        dispatch(setUpgradesError("Community could not be saved"));
    }
};

export const getUpgrades =
    ({ communityId }) =>
        async (dispatch) => {
            dispatch(toggleUpgradesLoading(true));
            const packages = (
                await firestore.doc(`${COMM_COLL}/${communityId}`).collection("upgrades").doc("upgradePackages").get()
            ).data();
            const capitalCosts =
                (
                    await firestore.doc(`${COMM_COLL}/${communityId}`).collection("upgrades").doc("capitalCosts").get()
                ).data() || {};
            dispatch(setInitUpgradePackages({ packages }));
            dispatch(setUpgradePackages({ packages }));
            dispatch(initCapitalCosts({ capitalCosts }));
            dispatch(toggleUpgradesLoading(false));
        };

export const updateUpgradeCodes =
    ({ newCodeRef, oldCodeRef, values = {}, fieldName }) =>
        (dispatch, getState) => {
            const { upgrades: { packages = {} } = {} } = getState();

            if (isEmpty(packages)) {
                //TODO: LAUREN - In this case there are no upgrades. Can I just put a return statement like this?
                return;
            }

            //If we get to this point, we assume that there are upgrades present

            // - Go into each upgrade in each package
            const updatedPackages = cloneDeep(packages);
            Object.keys(packages).forEach((packageKey) => {
                const { upgrades = {} } = packages[packageKey];
                // - In each upgrade, search fields for the code type with the oldCodeRef value
                Object.keys(upgrades).forEach((upgradeKey) => {
                    const {
                        fields: {
                            [fieldName]: { codeRef = "" } = {},
                            wall: {
                                [fieldName]: { codeRef: foundationWallCodeRef = "" } = {},
                                ponyWall: { [fieldName]: { codeRef: ponyWallCodeRef = "" } = {} } = {},
                                ponyWall = {},
                            } = {},
                            wall = {},
                            floor: { [fieldName]: { codeRef: foundationFloorCodeRef = "" } = {} } = {},
                            floor = {},
                        } = {},
                        fields = {},
                    } = upgrades[upgradeKey];

                    // - If found, update this field and its RValues to be the new ones coming in
                    // - Values will be an obj with the fields that need changed - can spread them into the root of the fields obj
                    if (codeRef === oldCodeRef) {
                        //Typical flat component
                        updatedPackages[packageKey].upgrades[upgradeKey].fields = {
                            ...fields,
                            ...values,
                        };
                    } else if (foundationWallCodeRef === oldCodeRef) {
                        //Spread changes into foundation wall
                        updatedPackages[packageKey].upgrades[upgradeKey].fields.wall = { ...wall, ...values };
                    } else if (foundationFloorCodeRef === oldCodeRef) {
                        //Spread changes into foundation floor
                        updatedPackages[packageKey].upgrades[upgradeKey].fields.floor = { ...floor, ...values };
                    } else if (ponyWallCodeRef === oldCodeRef) {
                        //Spread changes into foundation ponywall
                        updatedPackages[packageKey].upgrades[upgradeKey].fields.wall.ponyWall = { ...ponyWall, ...values };
                    }
                });
            });

            dispatch(setUpgradePackages({ packages: updatedPackages }));
        };